<template>
    <div class="neural-drive">
        <div class="neural-drive-horizontal" v-if="direction === 'horizontal'">
            <div class="neural-drive">
                <div v-for="(item, index) in driveData" :key="index" class="neural-drive-block" :class="item.dataSource">
                    <baseInfoWrap :useBorder="false" textColor="#828489" titleColor="black" :title="item.title">
                        <table class="neural-drive-table">
                            <tr>
                                <td class="neural-drive-cell neural-drive-cell1" rowspan="3">
                                    <div class="icon-area">
                                        <div class="icon-area-main" :class="`${item.icon}`"></div>
                                        <div class="icon-area-text">{{ item.name }}</div>
                                    </div>
                                </td>
                                <td class="neural-drive-cell neural-drive-cell2" colspan="2">
                                    <div class="slot-area">
                                        <div class="slot-title">插槽一</div>
                                        <div class="slot-content">{{ getCellData(item.dataSource, 'slot1') | slotFilter }}</div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="neural-drive-cell neural-drive-cell3" colspan="2">
                                    <div class="slot-area">
                                        <div class="slot-title">插槽二</div>
                                        <div class="slot-content">{{ getCellData(item.dataSource, 'slot2') | slotFilter }}</div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="neural-drive-cell neural-drive-cell4" colspan="2">
                                    <div class="slot-area">
                                        <div class="slot-title">插槽三</div>
                                        <div class="slot-content">{{ getCellData(item.dataSource, 'slot3') | slotFilter}}</div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="neural-drive-cell neural-drive-cell5">
                                    <div class="level-area">
                                        <div class="level-title">等級一</div>
                                        <div class="level-content" v-html="getCellData(item.dataSource, 'level1')"></div>
                                    </div>
                                </td>
                                <td class="neural-drive-cell neural-drive-cell6">
                                    <div class="level-area">
                                        <div class="level-title">等級二</div>
                                        <div class="level-content" v-html="getCellData(item.dataSource, 'level2')"></div>
                                    </div>
                                </td>
                                <td class="neural-drive-cell neural-drive-cell7">
                                    <div class="level-area">
                                        <div class="level-title">等級三</div>
                                        <div class="level-content" v-html="getCellData(item.dataSource, 'level3')"></div>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="['gamma', 'gamma1', 'gamma2'].includes(item.dataSource)">
                                <td class="neural-drive-cell neural-drive-cell8">
                                    <div class="level-area">
                                        <div class="level-title">等級四</div>
                                        <div class="level-content" v-html="getCellData(item.dataSource, 'level4')"></div>
                                    </div>
                                </td>
                                <td class="neural-drive-cell neural-drive-cell9">
                                    <div class="level-area">
                                        <div class="level-title">等級五</div>
                                        <div class="level-content" v-html="getCellData(item.dataSource, 'level5')"></div>
                                    </div>
                                </td>
                                <td class="neural-drive-cell neural-drive-cell10">
                                    <div class="level-area">
                                        <div class="level-title">等級六</div>
                                        <div class="level-content" v-html="getCellData(item.dataSource, 'level6')"></div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </baseInfoWrap>
                </div>
            </div>
        </div>
        <div class="neural-drive-vertical" v-else>
            <baseInfoWrap :useBorder="false" textColor="#828489" titleColor="black" title="SHEN JING QU DONG">
                <div class="neural-drive-table-wrap">
                    <table class="neural-drive-table" v-for="(item, index) in driveData" :key="index"
                        :class="`neural-drive-table${index}`">
                        <tr>
                            <td class="neural-drive-cell neural-drive-cell1" rowspan="3">
                                <div class="icon-area">
                                    <div class="icon-area-main" :class="`${item.icon}`"></div>
                                    <div class="icon-area-text">{{ item.name }}</div>
                                </div>
                            </td>
                            <td class="neural-drive-cell neural-drive-cell2" colspan="2">
                                <div class="slot-area">
                                    <div class="slot-title">插槽一</div>
                                    <div class="slot-content">{{ getCellData(item.dataSource, 'slot1') | slotFilter }}</div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="neural-drive-cell neural-drive-cell3" colspan="2">
                                <div class="slot-area">
                                    <div class="slot-title">插槽二</div>
                                    <div class="slot-content">{{ getCellData(item.dataSource, 'slot2') | slotFilter }}</div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="neural-drive-cell neural-drive-cell4" colspan="2">
                                <div class="slot-area">
                                    <div class="slot-title">插槽三</div>
                                    <div class="slot-content">{{ getCellData(item.dataSource, 'slot3') | slotFilter }}</div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="neural-drive-cell neural-drive-cell5">
                                <div class="level-area">
                                    <div class="level-title">等級一</div>
                                    <div class="level-content" v-html="getCellData(item.dataSource, 'level1')"></div>
                                </div>
                            </td>
                            <td class="neural-drive-cell neural-drive-cell6">
                                <div class="level-area">
                                    <div class="level-title">等級二</div>
                                    <div class="level-content" v-html="getCellData(item.dataSource, 'level2')"></div>
                                </div>
                            </td>
                            <td class="neural-drive-cell neural-drive-cell7">
                                <div class="level-area">
                                    <div class="level-title">等級三</div>
                                    <div class="level-content" v-html="getCellData(item.dataSource, 'level3')"></div>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="['gamma', 'gamma1', 'gamma2'].includes(item.dataSource)">
                            <td class="neural-drive-cell neural-drive-cell8">
                                <div class="level-area">
                                    <div class="level-title">等級四</div>
                                    <div class="level-content" v-html="getCellData(item.dataSource, 'level4')"></div>
                                </div>
                            </td>
                            <td class="neural-drive-cell neural-drive-cell9">
                                <div class="level-area">
                                    <div class="level-title">等級五</div>
                                    <div class="level-content" v-html="getCellData(item.dataSource, 'level5')"></div>
                                </div>
                            </td>
                            <td class="neural-drive-cell neural-drive-cell10">
                                <div class="level-area">
                                    <div class="level-title">等級六</div>
                                    <div class="level-content" v-html="getCellData(item.dataSource, 'level6')"></div>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </baseInfoWrap>
        </div>
    </div>
</template>

<script>
import baseInfoWrap from './base/baseInfoWrap.vue';
export default {
    components: { baseInfoWrap },
    props: {
        direction: {
            type: String,
            default: 'horizontal'  //horizontal||vertical
        },
        originData: {
            type: Object,
            default: () => { }
        }
    },
    filters: {
        slotFilter(value) {
            switch (value) {
                case 'Attack':
                    return '紅色晶片'
                case 'Dodge':
                    return '黃色晶片'
                case 'Critical':
                    return '藍色晶片'
                default:
                    return value
            }
        }
    },
    computed: {
        neuralDriveData() {
            return this.originData && this.originData.neuralDrive ? this.originData.neuralDrive : {}
        },
        driveData() {
            if (this.neuralDriveData.hasOwnProperty('gamma')) {
                return [
                    {
                        dataSource: 'alpha',
                        title: 'A ER FA',
                        name: '阿爾法區',
                        icon: 'alpha-icon'
                    },
                    {
                        dataSource: 'beta',
                        title: 'BEI TA',
                        name: '貝塔區',
                        icon: 'beta-icon'
                    },
                    {
                        dataSource: 'gamma',
                        title: 'GA MA',
                        name: '伽馬區',
                        icon: 'gamma-icon'
                    }
                ]
            } else {
                return [
                    {
                        dataSource: 'alpha',
                        title: 'A ER FA',
                        name: '阿爾法區',
                        icon: 'alpha-icon'
                    },
                    {
                        dataSource: 'beta',
                        title: 'BEI TA',
                        name: '貝塔區',
                        icon: 'beta-icon'
                    },
                    {
                        dataSource: 'gamma1',
                        title: 'GA MA 1',
                        name: '伽馬1區',
                        icon: 'gamma1-icon'
                    },
                    {
                        dataSource: 'gamma2',
                        title: 'GA MA 2',
                        name: '伽馬2區',
                        icon: 'gamma2-icon'
                    }
                ]
            }
        },
    },
    methods: {
        getCellData(dataSource, attr) {
            if (this.neuralDriveData.hasOwnProperty(dataSource)) {
                if (this.neuralDriveData[dataSource][attr]) {
                    return this.neuralDriveData[dataSource][attr]
                } else {
                    return '-'
                }
            } else {
                return '-'
            }
        }
    }
}
</script>

<style scoped lang="scss">
.neural-drive {
    width: 100%;

    .neural-drive-horizontal {
        .neural-drive {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-template-rows: repeat(1fr, 1.5fr);
            gap: .15rem;

            .neural-drive-block {
                height: 100%;
                width: 5.43rem;

                .neural-drive-table {
                    border-collapse: collapse;
                    border-spacing: 0;
                    table-layout: fixed;
                    width: 100%;
                    height: 100%;

                    .neural-drive-cell {
                        border-color: black;
                        border-style: solid;
                        border-width: 1px;

                        .slot-area {
                            height: 100%;
                            position: relative;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            .slot-title {
                                width: 50%;
                                text-align: center;
                                font-weight: bold;
                                font-size: .24rem;
                            }

                            .slot-content {
                                width: 50%;
                                text-align: center;
                                font-size: .2rem;
                                color: #404040;
                            }
                        }

                        .level-area {
                            height: 100%;
                            position: relative;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: flex-start;
                            padding: .15rem;
                            box-sizing: border-box;

                            .level-title {
                                text-align: center;
                                font-weight: 600;
                                font-size: .24rem;
                                margin-bottom: .05rem;
                            }

                            .level-content {
                                flex: 1;
                                text-align: center;
                                font-size: .2rem;
                                color: #404040;
                                word-break: break-word;
                            }
                        }
                    }

                    .neural-drive-cell1 {
                        width: 1.8rem;
                        height: 1.15rem;
                        background-color: #72747a;

                        .icon-area {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;

                            &-text {
                                margin-top: .04rem;
                                color: white;
                                font-weight: 500;
                                font-size: .24rem;
                            }
                        }
                    }

                    .neural-drive-cell2,
                    .neural-drive-cell3,
                    .neural-drive-cell4 {
                        background-color: #f2f2f4;
                        height: .38rem;
                    }

                    .neural-drive-cell5,
                    .neural-drive-cell6,
                    .neural-drive-cell7,
                    .neural-drive-cell8,
                    .neural-drive-cell9,
                    .neural-drive-cell10 {
                        background-color: #e2edf6;
                    }

                }
            }

        }
    }

    .neural-drive-vertical {
        .neural-drive-table-wrap {
            .neural-drive-table {
                border-collapse: collapse;
                border-spacing: 0;
                table-layout: fixed;
                width: 100%;

                .neural-drive-cell {
                    border-color: black;
                    border-style: solid;
                    border-width: 1px;

                    .slot-area {
                        height: 100%;
                        position: relative;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        .slot-title {
                            width: 50%;
                            text-align: center;
                            font-weight: bold;
                            font-size: .24rem;
                        }

                        .slot-content {
                            width: 50%;
                            text-align: center;
                            font-size: .2rem;
                            color: #404040;
                        }
                    }

                    .level-area {
                        height: 100%;
                        position: relative;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: flex-start;
                        padding: .15rem;
                        box-sizing: border-box;

                        .level-title {
                            text-align: center;
                            font-weight: 600;
                            font-size: .24rem;
                            margin-bottom: .05rem;
                        }

                        .level-content {
                            flex: 1;
                            text-align: center;
                            font-size: .2rem;
                            color: #404040;
                            word-break: break-word;
                        }
                    }
                }

                .neural-drive-cell1 {
                    width: 1.8rem;
                    height: 1.15rem;
                    background-color: #72747a;

                    .icon-area {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;

                        &-text {
                            margin-top: .04rem;
                            color: white;
                            font-weight: 500;
                            font-size: .24rem;
                        }
                    }
                }

                .neural-drive-cell2,
                .neural-drive-cell3,
                .neural-drive-cell4 {
                    background-color: #f2f2f4;
                    height: .38rem;
                }

                .neural-drive-cell5,
                .neural-drive-cell6,
                .neural-drive-cell7,
                .neural-drive-cell8,
                .neural-drive-cell9,
                .neural-drive-cell10 {
                    background-color: #e2edf6;
                }
            }
        }

    }

}
</style>